/* eslint-disable i18next/no-literal-string */
import { Select, FieldList, Link } from '@hotjar/hotsauce';
import type { ConnectVisitData } from '@hotjar/feedback/domain/Surveys/Survey/Survey';
import styled from '@emotion/styled';
import { useHelpHotjarUrl, useTranslation } from '@hotjar/translations';

const StyledLink = styled(Link)`
  text-decoration: underline;
  background: none;
`;

interface QuestionConnectVisitDataProps {
  connectVisitData: ConnectVisitData;
  onChange: (newValue: ConnectVisitData) => void;
}

export function QuestionConnectVisitData({
  connectVisitData = 'always',
  onChange,
}: QuestionConnectVisitDataProps): JSX.Element {
  const { t } = useTranslation('feedback', { keyPrefix: 'wizard.section.questions.connect-data' });
  const helpHotjarUrl = useHelpHotjarUrl();
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    function isValidValue(value: string): value is ConnectVisitData {
      switch (value) {
        case 'always':
        case 'ask':
        case 'never':
          return true;
        default:
          return false;
      }
    }
    const newValue = event.target.value;
    if (isValidValue(newValue)) {
      onChange(newValue);
    }
  };

  return (
    <FieldList
      title={t('title')}
      helperText={
        <>
          {t('helper')}{' '}
          <StyledLink
            isExternal
            href={`${helpHotjarUrl}/articles/360003470413#auto-connect`}
            kind="inline"
          >
            {t('helper-link')}
          </StyledLink>
        </>
      }
    >
      <Select
        aria-label={t('select-aria-label')}
        value={connectVisitData}
        id="connect_visit_data"
        onChange={handleChange}
        size="s"
      >
        <option value="always">{t('option-always')}</option>
        <option value="ask">{t('option-ask')}</option>
        <option value="never">{t('option-never')}</option>
      </Select>
    </FieldList>
  );
}
